export const getLoginLink = (config) => {
    return `/login`;
};

export const getRegisterLink = (config) => {
    return `${config?.config?.baseUrl}/general/users/register?promotion=${config?.config?.directoryName}`;
};

export const getAccountLink = (config) => {
    return `${config?.config?.baseUrl}/general/users/register?promotion=${config?.config?.directoryName}`;
};

export const getForgotPasswordLink = (config) => {
    return `${config?.config?.baseUrl}/general/users/forgot`;
};

export const getSSOLink = (config) => {
    return `${config?.config?.baseUrl}/sso?redirect=${config?.config?.directoryName}`;
};
